import { Form, Field, FormElement, FieldWrapper, FieldRenderProps, FormRenderProps } from '@progress/kendo-react-form';
import { Label, Error, Hint, FloatingLabel } from '@progress/kendo-react-labels';
import { Input } from '@progress/kendo-react-inputs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCheck, faClose, faInfoCircle, faTrash} from '@fortawesome/free-solid-svg-icons';
import { docLinks } from './Configuration';
import { DocLinks } from '../services/interfaces';
import { Annotorious, OpenSeadragonAnnotator, OpenSeadragonViewer, OpenSeadragonAnnotationPopup, ImageAnnotation, AnnotationState, DrawingStyle, UserSelectAction, useAnnotations, useAnnotator, AnnotoriousOpenSeadragonAnnotator, Annotation, PopupProps, AnnotationBody, User, OpenSeadragonViewerProps} from '@annotorious/react';
import { Button } from '@progress/kendo-react-buttons';
import { MouseEvent, useContext, useEffect, useState, useRef, MouseEventHandler } from 'react';
import { PageContext } from './PageContext';
import { elements } from '@progress/kendo-react-common';
import { Switch,SwitchChangeEvent } from '@progress/kendo-react-inputs';
import { UserContext } from './UserContext';
import { SubmissionContext } from './SubmissionFormContext';
import { ColorPicker, ColorPickerChangeEvent } from '@progress/kendo-react-inputs';
import { getShareLinkUrl} from '../services/apiService';
import { SubmitAnnotation } from './InfoBoxes';

interface ExtendedPopupProps extends PopupProps {
  readOnly: Boolean
  onDelete: MouseEventHandler<HTMLButtonElement>;
  onSaveNotes: (annotation: ImageAnnotation) => void;
  onClose: MouseEventHandler<HTMLButtonElement>;
}

const AnnotationLoader=()=>{
    const annotator = useAnnotator<AnnotoriousOpenSeadragonAnnotator>();
    const [annos, setAnnos] = useState<ImageAnnotation[] | "error">([]);
    const subContext=useContext(SubmissionContext);

    useEffect(()=>{
        if (annotator){
            if (subContext?.submitForm.annotations && subContext?.submitForm.annotations.length>0){
                setAnnos(subContext.submitForm.annotations);                
            };
        }
    },[annotator])

    useEffect(()=>{
        if (annos!="error" && annotator){
            annotator.setAnnotations(annos)
        }
    },[annos])

    return null;
}

export const CommentPopup = (props: ExtendedPopupProps) => {
    const { annotation, onCreateBody, onUpdateBody } = props;
    const [comment, setComment] = useState('');
    const userContext = useContext(UserContext);
    const user:User = {
        name:userContext?.user.fullName||'',
        id:userContext?.user.username||''
       }
    useEffect(() => {
      const commentBody = annotation.bodies.find(body => body.purpose === 'commenting');
      setComment(commentBody?.value ?? '');
    }, [annotation.bodies]);
    
    const onSave = (e:MouseEvent) => {
        e.preventDefault();
        const updated:Partial<AnnotationBody> = {
          annotation: annotation.id,
          purpose: 'commenting',
          value: comment,
          creator:user
        };
        //console.log(updated);
        const commentBody = annotation.bodies.find(body => body.purpose === 'commenting');
        if (commentBody) {
          console.log("UpdateBody");
          console.log(commentBody);
          //clear the bodies so there's always only one body per annotation.
          annotation.bodies=[];
          annotation.bodies.push({
            ...updated,
            id: updated.id || 'atol-notation-' + Date.now() // Ensure 'id' is defined
          } as AnnotationBody);
          //onUpdateBody(commentBody, updated);
        } else {
          console.log("CreateBody");
          annotation.bodies.push({
            ...updated,
            id: updated.id || 'atol-notation-' + Date.now() // Ensure 'id' is defined
          } as AnnotationBody);
          //onCreateBody(updated);
        };
        //console.log(annotation);
        props.onSaveNotes(annotation);
    }

    return (
    <>
        {/* <svg aria-hidden="true" width="14" height="14" viewBox="0 0 14 14" style={{position:"absolute", pointerEvents:"none", bottom:"100%", transform:"rotate(180deg)", left:"103px"}}><path stroke="none" fill='white' d="M0,0 H14 L7,7 Q7,7 7,7 Z"></path><clipPath id=":r1:"><rect x="0" y="0" width="14" height="14"></rect></clipPath></svg> */}
        <div>{annotation.target.creator?.id}&nbsp;{annotation.target.created?.toDateString()}<br/>{annotation.target.created?.toTimeString()}</div>
        {!props.readOnly?        
            <textarea
            maxLength={3096}
            value={comment}
            onChange={e => setComment(e.target.value)} />
        : <p>{comment}</p>
        }
        {!props.readOnly?<>
        <Button fillMode={"flat"} onClick={onSave}><FontAwesomeIcon style={{color:"green"}} icon={faCheck} />&nbsp;Save</Button>
        <Button fillMode={"flat"} onClick={props.onDelete}><FontAwesomeIcon style={{color:"red"}} icon={faTrash} />&nbsp;Delete</Button>
        <Button fillMode={"flat"} onClick={props.onClose}><FontAwesomeIcon style={{color:"red"}} icon={faClose} />&nbsp;Close</Button>
        </>:null}
    </>
    )
}

function ATOLAnnotator(){
    const pageContext=useContext(PageContext);
    const userContext = useContext(UserContext);
    const submitContext = useContext(SubmissionContext);
    const [annoColor, setAnnoColor]=useState('rgba(255, 0, 0, 1)');
    const imgURL = pageContext?.proofFiles?.thumbURL + "&t=" + new Date().getMilliseconds() ||"";
    console.log(imgURL);
    const annStyle = (annotation: ImageAnnotation, state?: AnnotationState): DrawingStyle => ({
        fill: state?.hovered ? (annoColor as any) : (annoColor as any),
        fillOpacity: 0.25
      });
    //why isn't this working
    const myanno = useRef<AnnotoriousOpenSeadragonAnnotator | null>(null);
    const myviewer = useRef<OpenSeadragon.Viewer>(null);
    const editMode = useRef<boolean>(true);

    const user:User = {
        name:userContext?.user.fullName||'',
        id:userContext?.user.username||''
    }
    const UserSelect=(a: Annotation): UserSelectAction=>{
        return UserSelectAction.EDIT;
    }

    const handleModeToggle=(e:SwitchChangeEvent)=>{
        if (e.value==true){
            editMode.current=true;
            myanno.current?.setDrawingEnabled(true);
        }else{
            editMode.current=false;
            myanno.current?.setDrawingEnabled(false);
        }
    }

    const checkState=()=>{
        console.log(submitContext?.submitForm);
    }

    const saveNotes=(annotation:ImageAnnotation)=>{
        //annotation.target.creator=user;
        console.log(annotation);
        if (submitContext?.submitForm) {
            if (submitContext.submitForm.annotations.length>0){
                var newAnnoList:ImageAnnotation[]=[];
                var found = false;
                submitContext.submitForm.annotations.forEach(anno=>{
                    if (anno.id == annotation.id){
                        newAnnoList.push(annotation);
                        found=true;
                    }else{
                        newAnnoList.push(anno);
                    }
                });
                if (found==false){
                        newAnnoList.push(annotation);
                }
                submitContext.submitForm.annotations=newAnnoList;
                submitContext.submitForm.hasAnnotations=true;
            }else{
                submitContext.submitForm.annotations = [...submitContext.submitForm.annotations, annotation];
                submitContext.submitForm.hasAnnotations=true;
            }
        }
        checkState();
        myanno.current?.updateAnnotation(annotation);
        myanno.current?.setSelected(undefined);       
    }

    const handleDelete=(e:MouseEvent)=>{
        e.preventDefault();
        const selected = myanno.current?.getSelected();
        if (window.confirm("Are you sure you want to delete this annotation?")){
            if (selected && selected.length > 0) {
                myanno.current?.removeAnnotation(selected[0]);
                console.log(selected[0]);
            }    
        }
        if (selected){
            if (submitContext){
                const newArray = [...(submitContext.submitForm.annotations)];
                const index = submitContext?.submitForm.annotations.findIndex(item => item.id === selected[0].id);
                if (index !== -1) {
                    newArray.splice(index, 1);
                    submitContext.submitForm.annotations = newArray;
                }
            }
        }
      
    }

    const handleDeleteAll=(e:MouseEvent)=>{
        e.preventDefault();
        if (window.confirm("Are you sure you want to delete all the active annotations? This action can not be undone.")){
            if (submitContext && submitContext.submitForm.annotations.length>0){
                submitContext.submitForm.annotations.forEach(anno=>{
                    myanno.current?.removeAnnotation(anno);
                });
                submitContext.submitForm.annotations = [];
            }
        }      
    }

    const closeNote=()=>{
        myanno.current?.setSelected(undefined);       
    }

    const createBody=(body:AnnotationBody)=>{
        console.log("Create Body");
        console.log(body);
        if (myanno.current){
            var thisAnno = myanno.current.getSelected()[0];
            thisAnno.bodies.push(body);
            console.log(thisAnno);
        }
    }

    const setColor=(val:ColorPickerChangeEvent)=>{
        setAnnoColor(val.value);
        loadNotes();
    }

    const getNotes=(e:MouseEvent)=>{
        e.preventDefault();
        loadNotes();
    }

    //const annotator = useAnnotator();

    const loadNotes=()=>{
        console.log("Load Notes");
        if (myanno.current){
            console.log("MyAnno exists");
            myanno.current.setDrawingEnabled(true);
            if ((submitContext?.submitForm.annotations ?? []).length > 0){
                console.log("setAnnotations");
                myanno.current.setAnnotations(submitContext?.submitForm.annotations || [],true);
            }
        }
    }

    const stopScroll=(event: Event)=>{
        console.log("Why is this scrolling");
        event.preventDefault();
    }
    const onFullScreen=()=>{
        console.log("Full Screen Clicked");
    }

    const preventDefault=(event: any)=>{
        console.log(event);
        console.log("event handler fired")
    }
    
    useEffect(() => {
        loadNotes();
    }, [myanno.current]);

    useEffect(()=>{
        console.log("Viewer initialized");
        console.log(pageContext?.proofFiles.thumbURL);
    },[myviewer])

    useEffect(()=>{
        
    },[]);
    return(
            <div style={{width:"95%"}}>
            <div className='mb-3'>
                Mode: <Switch defaultChecked={editMode.current} onChange={handleModeToggle} onLabel={"Add"} offLabel={"Edit"}/>&nbsp;
                Notation color: <ColorPicker value={annoColor} onChange={setColor}/>
                <Button onClick={handleDeleteAll} style={{marginLeft:"10px", marginRight:"10px"}}><FontAwesomeIcon icon={faTrash} />&nbsp;Delete All</Button>&nbsp;
            </div>
            
            <OpenSeadragonAnnotator
                ref={myanno}
                style={annStyle} 
                tool={"rectangle"}
                drawingEnabled={editMode.current}
                drawingMode='click'
                userSelectAction={UserSelect}
                user={user}
            >
                <OpenSeadragonViewer
                    ref={myviewer}
                    className='noteImage'
                    options={{
                        tileSources:{
                            type:"image",
                            url: pageContext?.proofFiles.thumbURL,
                            //crossOriginPolicy:"Annonymous",
                            ajaxWithCredentials:false,
                        },
                        showFullPageControl:false,
                        showHomeControl:true,
                        defaultZoomLevel:1,
                        minZoomLevel:.25,
                        maxZoomLevel:4,
                        preserveViewport:true,
                        gestureSettingsMouse:{clickToZoom:false, scrollToZoom:false},
                        prefixUrl:"https://cdn.jsdelivr.net/npm/openseadragon@latest/build/openseadragon/images/"
                    }}
                />
                <OpenSeadragonAnnotationPopup
                    popup={props => (
                        <CommentPopup {...props} readOnly={false} onCreateBody={createBody} onDelete={handleDelete} onSaveNotes={saveNotes} onClose={closeNote} />
                )} />
            </OpenSeadragonAnnotator>
            <AnnotationLoader></AnnotationLoader>
            </div>
    )
}

const Notation=()=>{
    const [crtProof, setCrtProof]=useState("");
    const pageContext=useContext(PageContext);
    if (pageContext?.selectedAd.temp6=="Built by Creatopy"){
        var adSlug = pageContext?.selectedAd.slug;
        //var url = "/Home/GetShareLinkURL?element=" + adSlug + "&embed=true";
        getShareLinkUrl(adSlug,true).then(data=>{
            console.log(data);
            setCrtProof(data);                   
        })
        return(
            <iframe title="Creatopy Proof" id="crtProofFrame" src={crtProof} style={{width:"100%",height:"88vh"}}></iframe>     
        )     
    }else{
        return(
        <Annotorious>
            <ATOLAnnotator></ATOLAnnotator>
        </Annotorious>
        )
    }

} 

export const SubmitNotations =(
    <>
        <h5>ANNOTATIONS</h5>
        <SubmitAnnotation/>
        <Notation/>
    </>
)
